var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50006 0.582153C3.68686 0.582154 0.580078 3.69034 0.580078 7.50354C0.580078 11.3167 3.68686 14.4179 7.50006 14.4179C11.3133 14.4179 14.42 11.3167 14.42 7.50354C14.42 3.69034 11.3133 0.582153 7.50006 0.582153ZM7.50006 2.02446C8.78317 2.02446 9.96129 2.46221 10.8931 3.19634L3.17595 10.8713C2.45304 9.94319 2.02239 8.77578 2.02239 7.50354C2.02239 4.46982 4.46634 2.02446 7.50006 2.02446ZM11.8988 4.23018C12.5773 5.14217 12.9777 6.27503 12.9777 7.50354C12.9777 10.5373 10.5338 12.9812 7.50006 12.9812C6.26077 12.9812 5.12025 12.5733 4.20416 11.884L11.8988 4.23018Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockContact);
export default __webpack_public_path__ + "static/media/block_contact.481763160ce97f02aa5092c834262cc2.svg";
export { ForwardRef as ReactComponent };